goog.provide("shadow.js.shim.module$$mui$material$Card");
goog.provide("module$shadow_js_shim_module$$mui$material$Card");
shadow.js.shim.module$$mui$material$Card = shadow.js.nativeProvides["@mui/material/Card"] = shadow$bridge("@mui/material/Card");
module$shadow_js_shim_module$$mui$material$Card.default = shadow.js.shim.module$$mui$material$Card;
